export default __webpack_public_path__ + "static/Orange_Line-251e6741aa86bf8409422ed8cb4cc5c7.jpg";